import { Svg, CargoToken, LabeledValue_Value, LabeledValue_Label } from 'emerald-ui';
import { gray6, focus, gray7 } from 'emerald-ui/dist/globals/colors';
import styled from 'styled-components';
import { ExternalLinkLight } from 'emerald-icons/dist/ExternalLinkLight';
import { font } from 'emerald-ui/dist/globals/fonts';
import { theme } from '../../styles/theme';

export const CargoToken_Styled = styled(CargoToken)`
    font-size: 1rem !important;
`;

export const CargoWidget_Button = styled.button`
    outline: none;
    padding: 0;
    margin-top: .5em;
    fill: ${gray6};
    color: ${gray6};
    :hover, :focus {
        svg{
            fill: ${focus};
            color: ${focus};
        }
    }
`;

export const CopyLinkIcon = styled(Svg)`
    width: 1.25em;
    margin: .25em 0 0 .5em;
    cursor: pointer;
`;

export const CargoWidget_DrillIn = styled(ExternalLinkLight)`
    align-self: baseline;
    font-size: 1.5rem;
    cursor: pointer;
`;

export const CargoWidget_Values = styled(LabeledValue_Value).attrs(() => ({
    as: 'div'
}))`
    color: ${gray7};
    font-size: 1rem;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-family: ${font.light};

    ${theme.breakpoints.down('sm')} {
        font-size: .75rem;
    }
`;

export const CargoWidget_Label = styled(LabeledValue_Label).attrs(() => ({
    as: 'div'
}))`
    ${theme.breakpoints.down('sm')} {
        font-size: .75rem;
    }
`;

export const CargoWidget_ContainerType = styled(LabeledValue_Label).attrs(() => ({
    as: 'div'
}))`
    white-space: nowrap;

    ${theme.breakpoints.down('sm')} {
        font-size: .75rem;
    }
`;

export const CargoWidget_ContainerNumber = styled(LabeledValue_Value).attrs(() => ({
    as: 'div'
}))`
    font-size: 1rem;
    white-space: nowrap;

    ${theme.breakpoints.down('sm')} {
        font-size: .75rem;
    }
`;
